module.exports = __webpack_public_path__ + "img/bg_1_3.2399f362.png";